export default () => ({
    MuiCssBaseline: {
        '@global': {
            body: {
                backgroundColor: '#e6ecf0',
            },
        },
    },
});